import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { DashboardTile } from "./DashboardTile";
import { makeStyles } from "@material-ui/core/styles";
import { AnalyticsSection } from "../../services/core/types";

type DashboardSectionProps = {
  section: AnalyticsSection;
};

const useStyles = makeStyles((theme) => {
  return {
    container: {},
    heading: {
      color: "#9f9f9f",
      fontSize: "1.2em",
      fontWeight: 600,
    },
  };
});

export const DashboardSection: React.FC<DashboardSectionProps> = ({
  section,
}) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h6" className={classes.heading}>
        {section.title}
      </Typography>
      <Grid container spacing={3} className={classes.container}>
        {section.tiles.map((tile, index) => {
          return <DashboardTile key={index} tile={tile} />;
        })}
      </Grid>
    </>
  );
};
